import React, { useRef, useEffect } from 'react';
import ReactPlayer from 'react-player/lazy';

interface HoverVideoPlayerProps {
  src: string;
}

const HoverVideoPlayer: React.FC<HoverVideoPlayerProps> = ({ src }) => {
  const playerRef = useRef<ReactPlayer>(null);

  useEffect(() => {
    // Cleanup function to release video resources
    return () => {
      if (playerRef.current) {
        const internalPlayer = playerRef.current.getInternalPlayer();
        if (internalPlayer && internalPlayer instanceof HTMLVideoElement) {
          // Pause and cleanup video element
          internalPlayer.pause();
          internalPlayer.removeAttribute('src');
          internalPlayer.load();
        }
      }
    };
  }, []);

  return (
    <div className="hover-video-player absolute inset-0 w-full h-full">
      <ReactPlayer
        ref={playerRef}
        url={src}
        className="react-player"
        playing={true}
        loop={true}
        muted={true}
        playsinline={true}
        width="100%"
        height="100%"
        config={{
          file: {
            attributes: {
              crossOrigin: 'use-credentials',
              style: {
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              },
            },
            forceVideo: true,
          },
        }}
        onError={(e: any) => console.warn(`Hover video failed to load: ${src}`, e)}
      />
    </div>
  );
};

export default HoverVideoPlayer;